<template>
    <v-container>
        <v-form>
            <v-text-field v-model="title" autofocus label="Judul"></v-text-field>

            <v-textarea v-model="content" label="Konten"></v-textarea>

            <div class="text-right">
                <v-btn @click="save" rounded color="primary" :loading="$store.get('loader/loading', 'saving')">Simpan</v-btn>
            </div>
        </v-form>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            title: null,
            content: null
        }
    },

    methods: {
        save() {
            this.$api.post('help', {
                title: this.title,
                content: this.content
            }, { loader: 'saving' })
                .then(response => {
                    if (response.data.created) {
                        this.$store.dispatch('flash/info', 'Bantuan dibuat')

                        this.$router.replace({ name: 'help.manage' })
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
        }
    }
}
</script>
